var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer",class:{ [`footer-${_vm.type}`]: _vm.type },attrs:{"data-background-color":_vm.backgroundColor}},[_c('div',{staticClass:"container-vue"},[_c('div',[_vm._v(" © "+_vm._s(_vm.year)+", made with "),_c('md-icon',[_vm._v("favorite")]),_vm._v(" by WCC for a better PO experience. ")],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }